import "./uqualModal.scss";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import errorImage from "assets/images/ErrorGraphic2.png";
import nafLogoImage from "assets/images/newAmericanFundingWhiteBackground.svg";
import uqualLogoImage from "assets/images/uqual-logo.png";
import { ReactComponent as CloseIcon } from "assets/images/xmark.svg";
import Modal from "components/modal/Modal";
import { Button } from "components/ui/button/Button";
import { getNhDealApplicationId, getProspectId, setSelfReferralInSession } from "features/authSlice";
import { useSubmitUqualReferalWithConsentMutation } from "pages/application/applicationService";
import { UQUAL_REDIRECT, UQUAL_COMPLETE_NOTE, UQUAL_CONTACT_NUMBER, UQUAL_MODAL_SUCCESS_HEADER, UQUAL_MODAL_SUCCESS_HEADER_SECONDARY, UQUAL_MODAL_SUCCESS_SUBHEADER_SECONDARY_BEFORE_NUMBER, UQUAL_MODAL_SUCCESS_SUBHEADER_SECONDARY_AFTER_NUMBER, UQUAL_MODAL_SUCCESS_DISCLAIMER_SECONDARY, UQUAL_MODAL_HEADER, UQUAL_MODAL_SUBHEADER, UQUAL_MODAL_ACCEPT_BUTTON, UQUAL_MODAL_DECLINE_BUTTON, UQUAL_MODAL_DISCLAIMER, UQUAL_MODAL_SUCCESS_BODY } from "utilities/Constant";
import useDesktopChecker from "hooks/useDesktopChecker";
import caretImage from "assets/images/caret-up.svg";

export interface UqualModalProps {
  onClose: () => void;
  isLoadInitialState?: boolean;
  isLoadSuccessState?: boolean;
}

export const UqualModalSuccess = () => {
  const isDesktop = useDesktopChecker();

  return (
    <div className="uqual-modal__success">
      <h5 className="uqual-modal__title thanks">{UQUAL_MODAL_SUCCESS_HEADER}</h5>
      <p className="uqual-modal__credit-point">{UQUAL_MODAL_SUCCESS_BODY}</p>
      <h5 className="uqual-modal__contact">{UQUAL_MODAL_SUCCESS_HEADER_SECONDARY}</h5>
      <h5 className="uqual-modal__contact info">
        {UQUAL_MODAL_SUCCESS_SUBHEADER_SECONDARY_BEFORE_NUMBER}
        {isDesktop ? (
          `${UQUAL_CONTACT_NUMBER}`
        ) : (
          <a
            onClick={() => (window.location.href = `tel:${UQUAL_CONTACT_NUMBER}`)}
            className="uqual-modal__contact number"
            onKeyDown={() => (window.location.href = `tel:${UQUAL_CONTACT_NUMBER}`)}
          >
            {UQUAL_CONTACT_NUMBER}
          </a>
        )}{" "}
        {UQUAL_MODAL_SUCCESS_SUBHEADER_SECONDARY_AFTER_NUMBER}
      </h5>
      <div className="uqual-modal__success-disclaimer">{UQUAL_MODAL_SUCCESS_DISCLAIMER_SECONDARY}</div>
      <hr />
      <h5 className="uqual-modal__subtitle">Vanessa R., Nevada</h5>

      <p className="uqual-modal__testimonial">
        "Chris is awesome! Currently working on getting all my credit situated and also going to get my husband involved, cause Lord knows we need it!
        So excited to get the ball rolling. Thanks again, Uqual! Everyone in this company and New American Funding I'm working with has just had the
        best attitude and it makes me so comfortable. Adding to note that Ruth Branham is super sweet, and everyone is always so great at
        communicating."
      </p>
      <div className="rating">
        <FontAwesomeIcon icon={solid("star")} />
        <FontAwesomeIcon icon={solid("star")} />
        <FontAwesomeIcon icon={solid("star")} />
        <FontAwesomeIcon icon={solid("star")} />
        <FontAwesomeIcon icon={solid("star")} />
      </div>
    </div>
  );
}

export default function UqualModal({ onClose, isLoadInitialState = true, isLoadSuccessState = true }: Readonly<UqualModalProps>) {
  const [isShowDisclaimer, setIsShowDisclaimer] = useState(false);
  const [isInitialState, setIsInitialState] = useState(true);
  const [isSuccessState, setIsSuccessState] = useState(true);
  const disclaimerIcon = isShowDisclaimer
    ? solid("caret-up")
    : solid("caret-down");
  const nhDealAppId = useSelector(getNhDealApplicationId);
  const prospectId = useSelector(getProspectId);
  const [submitUqualReferal] = useSubmitUqualReferalWithConsentMutation();
  const dispatch = useDispatch();

  const handleContinueClick = async () => {
    try {
      const isSuccess = await submitUqualReferal({ nhDealApplicationId: nhDealAppId, prospectId: prospectId }).unwrap();
      setIsInitialState(false);
      setIsSuccessState(isSuccess);
      dispatch(setSelfReferralInSession(true));
    } catch {
      setIsSuccessState(false);
    }
  };

  useEffect(() => {
    setIsInitialState(isLoadInitialState);
    setIsSuccessState(isLoadSuccessState);
  }, [isLoadInitialState, isLoadSuccessState])

  return (
    <div className="uqual-ref-modal">
      <Modal
        customHeader={
          <div className="uqual-modal__close-container">
            <button
              className="uqual-modal__close-button"
              onClick={onClose}
              aria-label="Close"
            >
              <CloseIcon />
            </button>
          </div>
        }
        customBody={
          <div className="uqual-modal__content">
            {isSuccessState && (
              <>
                <div className="logos-container">
                  <img
                    src={nafLogoImage}
                    alt="New American Funding Logo"
                    className="naf-logo"
                  />
                  <div>
                    <img
                      src={uqualLogoImage}
                      alt="Uqual Logo"
                      className="uqual-logo"
                    />
                  </div>
                </div>
                {isInitialState && (
                  <>
                    <h3 className="uqual-modal__title">
                      {UQUAL_MODAL_HEADER}
                    </h3>
                    <h5 className="uqual-modal__subtitle">
                      {UQUAL_MODAL_SUBHEADER}
                    </h5>
                    <div className="uqual-modal__action-button">
                      <Button
                        title={UQUAL_MODAL_ACCEPT_BUTTON}
                        type="round"
                        variant="primary"
                        size="large"
                        className="button-style"
                        onClick={handleContinueClick}
                      />
                      <Button
                        title={UQUAL_MODAL_DECLINE_BUTTON}
                        type="round"
                        variant="outline-primary"
                        size="large"
                        className="button-style"
                        onClick={onClose}
                      />
                      <Button
                        type="link-no-underline"
                        className={`read-disclaimer-button ${isShowDisclaimer ? "show" : "hide"
                          }-disclaimer`}
                        onClick={() => setIsShowDisclaimer(!isShowDisclaimer)}
                      >
                        <span>Read Disclaimer <img src={caretImage} alt="" /></span>
                      </Button>
                    </div>
                    {isShowDisclaimer && (
                      <p className="uqual-modal__text uqual-modal__disclaimer">
                        {UQUAL_MODAL_DISCLAIMER}
                      </p>
                    )}
                    <div className="uqual-modal__footer-text">
                      A Uqual Advisor will reach out shortly to walk you through your personalized readiness plan.
                    </div>
                  </>
                )}
                {!isInitialState && (
                  <>
                    {isSuccessState && <UqualModalSuccess />}
                  </>
                )}
              </>
            )}
            {!isSuccessState && (
              <div className="error">
                <h3 className="uqual-modal__title">Oops! Something Went Wrong</h3>
                <h5 className="uqual-modal__subtitle">
                  We're having a bit of technical trouble right now. Please{" "}
                  <a href={UQUAL_REDIRECT}>click here</a> to schedule your
                  consultation with a Uqual Advisor. We appreciate your patience!
                </h5>
                <div className="uqual-modal__error-image">
                  <img src={errorImage} alt="Error indicator graphic" />
                </div>
              </div>
            )}
          </div>
        }
      />
    </div>
  );
}
